import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { DateField, TextField } from '@roc/ui';
import { useStore } from '@roc/client-portal-shared/hooks';
import { formatDate, isNotBlank, parseDate } from '@roc/feature-utils';

interface LicenseFormContentProps {
  open: boolean;
}

export const LicenseEditModal = observer(({ open }: LicenseFormContentProps) => {
  const { docReviewStoreV2 } = useStore();
  const { licenseFormStore } = docReviewStoreV2;

  useEffect(() => {
    if (open) licenseFormStore.load(docReviewStoreV2.docReviewData);
  }, [open]);

  const handleChange = (field: string, value: any) => {
    licenseFormStore.onFieldChange(field, value);
  };

  const f = licenseFormStore.form.fields;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          label="License Number"
          value={f.licenseNumber.value}
          onChange={e => handleChange('licenseNumber', e.target.value)}
          name="licenseNumber"
          testId="licenseNumber"
          variant="outlined"
          fullWidth
          standaloneLabel
          error={isNotBlank(f.licenseNumber.error)}
          helperText={f.licenseNumber.error}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="License Type"
          value={f.licenseType.value}
          onChange={e => handleChange('licenseType', e.target.value)}
          name="licenseType"
          testId="licenseType"
          variant="outlined"
          fullWidth
          standaloneLabel
          error={isNotBlank(f.licenseType.error)}
          helperText={f.licenseType.error}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="License State"
          value={f.licenseState.value}
          onChange={e => handleChange('licenseState', e.target.value)}
          name="licenseState"
          testId="licenseState"
          variant="outlined"
          fullWidth
          standaloneLabel
          error={isNotBlank(f.licenseState.error)}
          helperText={f.licenseState.error}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Name On License"
          value={f.nameOnLicense.value}
          onChange={e => handleChange('nameOnLicense', e.target.value)}
          name="nameOnLicense"
          testId="nameOnLicense"
          variant="outlined"
          fullWidth
          standaloneLabel
          error={isNotBlank(f.nameOnLicense.error)}
          helperText={f.nameOnLicense.error}
        />
      </Grid>
      <Grid item xs={12}>
        <DateField
          label="License Issued Date"
          value={
            f.licenseIssuedDate.value ? parseDate(f.licenseIssuedDate.value) : null
          }
          onChange={value =>
            handleChange(
              'licenseIssuedDate',
              value ? formatDate(value, 'MM/dd/yyyy') : value
            )
          }
          error={isNotBlank(f.licenseIssuedDate.error)}
          errorText={f.licenseIssuedDate.error}
          format="MM/dd/yyyy"
          testId="licenseIssuedDate"
          inputVariant="outlined"
          fullWidth
          standaloneLabel
        />
      </Grid>
      <Grid item xs={12}>
        <DateField
          label="License Expiry Date"
          value={
            f.licenseExpiryDate.value ? parseDate(f.licenseExpiryDate.value) : null
          }
          onChange={value =>
            handleChange(
              'licenseExpiryDate',
              value ? formatDate(value, 'MM/dd/yyyy') : value
            )
          }
          error={isNotBlank(f.licenseExpiryDate.error)}
          errorText={f.licenseExpiryDate.error}
          format="MM/dd/yyyy"
          testId="licenseExpiryDate"
          inputVariant="outlined"
          fullWidth
          standaloneLabel
        />
      </Grid>
    </Grid>
  );
});
